__turbopack_context__.v({
  "chipList": "EventDateAndLocation-module-scss-module__zPJ09a__chipList",
});
